import axios from 'axios';
import Vue from 'vue';
export default class TituloService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    recolocarEmFilaDeEnvio(titulo) {
        return this._http.post('titulo/fila/recolocar', {
            id_titulo: titulo.id_titulo,
            cd_apresentante: this._store.getters.cdApresentante
        });
    }

    filtrarTitulos(filtros, nr_pagina, nr_titulos_pagina) {
        if (filtros.ds_agrupador === '') {
            filtros.ds_agrupador = null;
        }

        let cd_apresentante = this._store.getters.cdApresentante;
        if (filtros.apresentanteOrigem) {
            cd_apresentante = filtros.apresentanteOrigem;
        }

        return this._http.post(
            'consulta_titulos_paginada',
            {
                cd_apresentante,
                pagina: nr_pagina,
                titulos_por_pagina: nr_titulos_pagina,
                filtros
            },
            {
                // headers: {
                //     Authorization: 'Bearer ' + this._store.getters.token
                // }
            }
        );
    }

    buscarManutencao(filtros, nr_pagina, nr_titulos_pagina) {
        if (filtros.ds_agrupador === '') {
            filtros.ds_agrupador = null;
        }

        let cd_apresentante = this._store.getters.cdApresentante;
        if (filtros.apresentanteOrigem) {
            cd_apresentante = filtros.apresentanteOrigem;
        }

        return this._http.post(
            'lote/',
            {
                cd_apresentante,
                pagina: nr_pagina,
                titulos_por_pagina: nr_titulos_pagina,
                filtros
            },
            {
                // headers: {
                //     Authorization: 'Bearer ' + this._store.getters.token
                // }
            }
        );
    }

    async sendInstrucaoAnuencia(cd_apresentante, id_titulo) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    'titulos/enviar-email-instrucao-anuencia',
                {
                    cd_apresentante: cd_apresentante,
                    id_titulo: id_titulo
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response;
        } catch (error) {
            return error?.response;
        }
    }

    async pesquisaAvancadaTitulos(filtros, nr_pagina, nr_titulos_pagina) {
        try {
            // GET tem limite físico de URL (ALB/nginx ~8K). Para lista
            // "ilimitada", fatiamos em N GETs pequenos e unimos no front.
            const ITENS_POR_REQUEST = 50;
            const TRAVA_SEGURANCA = 5000;

            const normalizarLista = valor => {
                if (valor === null || valor === undefined) return null;
                const arr = String(valor)
                    .split(/[,;\s]+/)
                    .map(s => s.trim())
                    .filter(Boolean);
                return [...new Set(arr)];
            };

            const dsNossosNumeros = normalizarLista(filtros.ds_nosso_numero);
            const idsTitulo = normalizarLista(filtros.id_titulo);
            const protocolos = normalizarLista(
                filtros.apontamento_nu_protocolo
            );

            for (const lista of [dsNossosNumeros, idsTitulo, protocolos]) {
                if (lista && lista.length > TRAVA_SEGURANCA) {
                    throw {
                        status: 400,
                        data: {
                            msg: `Busca com ${lista.length} itens excede a trava de ${TRAVA_SEGURANCA}. Use exportação assíncrona (e-mail/SQS) ou um POST com body.`
                        }
                    };
                }
            }

            // Lista deve usar IN (índice) e não OR LIKE (full scan)
            let buscaExata = filtros.busca_exata;
            if (
                (dsNossosNumeros && dsNossosNumeros.length > 1) ||
                (idsTitulo && idsTitulo.length > 1)
            ) {
                buscaExata = true;
            }
            // Cessão e outros fluxos não enviam o flag -> default exata p/ lista
            if (buscaExata === undefined && (dsNossosNumeros || idsTitulo)) {
                buscaExata = true;
            }

            const montarParams = (dsChunk, idChunk, protChunk, pagina, porPagina) => ({
                pagina,
                titulos_por_pagina: porPagina,
                ds_nosso_numero: dsChunk ? dsChunk.join(',') : filtros.ds_nosso_numero,
                nu_identificacao_devedor: filtros.nu_identificacao_devedor,
                nm_devedor: filtros.nm_devedor,
                apontamento_nu_protocolo: protChunk
                    ? protChunk.join(',')
                    : filtros.apontamento_nu_protocolo,
                cd_revisao_interna: filtros.cd_revisao_interna,
                cd_apresentante: filtros.cd_apresentante,
                ds_email_devedor: filtros.ds_email_devedor,
                busca_exata: buscaExata,
                dt_apontamento_ate: filtros.dt_apontamento_ate,
                dt_apontamento_de: filtros.dt_apontamento_de,
                cd_ibge_comarca: filtros.cd_ibge_comarca,
                ds_revisao: filtros.ds_revisao || null,
                exportar_excel: filtros.exportar_excel,
                exportar_email: filtros.exportar_email,
                id_titulo: idChunk ? idChunk.join(',') : filtros.id_titulo || null,
                order_by: filtros.orderBy || null,
                order_direction: filtros.orderDir || null
            });

            const fazerGet = async params => {
                const config = {
                    params,
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                };
                if (filtros.exportar_excel) {
                    config.responseType = 'arraybuffer';
                }
                const response = await axios.get(
                    process.env.VUE_APP_RECUPERI_API +
                        `titulos/pesquisa-avancada-titulos`,
                    config
                );
                return response.data;
            };

            const precisaFatiar =
                (dsNossosNumeros && dsNossosNumeros.length > ITENS_POR_REQUEST) ||
                (idsTitulo && idsTitulo.length > ITENS_POR_REQUEST) ||
                (protocolos && protocolos.length > ITENS_POR_REQUEST);

            // Caso simples: 1 request
            if (!precisaFatiar) {
                return await fazerGet(
                    montarParams(
                        dsNossosNumeros,
                        idsTitulo,
                        protocolos,
                        nr_pagina,
                        nr_titulos_pagina
                    )
                );
            }

            // Exportação (arquivo) não dá para unir no front -> exige caminho assíncrono
            if (filtros.exportar_excel || filtros.exportar_email) {
                throw {
                    status: 400,
                    data: {
                        msg: 'Lista grande demais para exportação direta via GET. Use exportação por e-mail/SQS ou reduza a lista.'
                    }
                };
            }

            // Escolhe qual lista fatiar (caso típico: só uma é grande)
            let campoFatia = 'ds_nosso_numero';
            let listaFatia = dsNossosNumeros;
            if (!listaFatia || listaFatia.length <= ITENS_POR_REQUEST) {
                if (idsTitulo && idsTitulo.length > ITENS_POR_REQUEST) {
                    campoFatia = 'id_titulo';
                    listaFatia = idsTitulo;
                } else if (protocolos && protocolos.length > ITENS_POR_REQUEST) {
                    campoFatia = 'apontamento_nu_protocolo';
                    listaFatia = protocolos;
                }
            }
            // Se mais de uma lista é grande, o outro filtro manteria a URL grande
            const outrasGrandes =
                (campoFatia !== 'ds_nosso_numero' &&
                    dsNossosNumeros &&
                    dsNossosNumeros.length > ITENS_POR_REQUEST) ||
                (campoFatia !== 'id_titulo' &&
                    idsTitulo &&
                    idsTitulo.length > ITENS_POR_REQUEST) ||
                (campoFatia !== 'apontamento_nu_protocolo' &&
                    protocolos &&
                    protocolos.length > ITENS_POR_REQUEST);
            if (outrasGrandes) {
                throw {
                    status: 400,
                    data: {
                        msg: 'Múltiplos filtros com lista grande. O correto é um POST com body (sem limite de URL).'
                    }
                };
            }

            const chunks = [];
            for (let i = 0; i < listaFatia.length; i += ITENS_POR_REQUEST) {
                chunks.push(listaFatia.slice(i, i + ITENS_POR_REQUEST));
            }

            // Busca tudo de cada fatia (pagina=1, tudo do chunk) com concorrência limitada
            const CONCORRENCIA = 5;
            const todosTitulos = [];
            for (let i = 0; i < chunks.length; i += CONCORRENCIA) {
                const lote = chunks.slice(i, i + CONCORRENCIA);
                const resultados = await Promise.all(
                    lote.map(chunk => {
                        const dsChunk =
                            campoFatia === 'ds_nosso_numero' ? chunk : dsNossosNumeros;
                        const idChunk =
                            campoFatia === 'id_titulo' ? chunk : idsTitulo;
                        const protChunk =
                            campoFatia === 'apontamento_nu_protocolo'
                                ? chunk
                                : protocolos;
                        // traz tudo do chunk para paginar no front corretamente
                        return fazerGet(
                            montarParams(
                                dsChunk,
                                idChunk,
                                protChunk,
                                1,
                                chunk.length
                            )
                        );
                    })
                );
                for (const r of resultados) {
                    if (r && Array.isArray(r.titulos)) todosTitulos.push(...r.titulos);
                }
            }

            // Dedup por id_titulo
            const vistos = new Set();
            const unicos = [];
            for (const t of todosTitulos) {
                const k = t.id_titulo ?? `${t.ds_nosso_numero}`;
                if (!vistos.has(k)) {
                    vistos.add(k);
                    unicos.push(t);
                }
            }

            // Ordenação equivalente ao back quando pedida
            if (filtros.orderBy) {
                const campo = filtros.orderBy;
                const dir = filtros.orderDir === 'desc' ? -1 : 1;
                unicos.sort((a, b) => {
                    const va = a[campo];
                    const vb = b[campo];
                    if (va === vb) return 0;
                    if (va === null || va === undefined) return 1;
                    if (vb === null || vb === undefined) return -1;
                    return (va > vb ? 1 : -1) * dir;
                });
            }

            const total = unicos.length;
            const inicio = (nr_pagina - 1) * nr_titulos_pagina;
            return {
                total_titulos: total,
                titulos: unicos.slice(inicio, inicio + nr_titulos_pagina)
            };
        } catch (error) {
            throw error?.response || error;
        }
    }

    detalharTitulo(titulo) {
        return this._http.post('consulta_titulo/detalhe', {
            cd_apresentante: this._store.getters.cdApresentante,
            id_titulo: titulo.id_titulo
        });
    }

    async checarTituloIrregularNaoReapresentado(titulo) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/checar-irregularidade-nao-reapresentado/${titulo.id_titulo}/`,
                {
                    params: {
                        cd_apresentante: titulo.cd_apresentante
                    },
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    detalharTituloView(titulo) {
        return this._http.post('consulta_titulo/detalhe', {
            cd_apresentante: titulo.cd_apresentante,
            id_titulo: titulo.id_titulo
        });
    }

    buscarAnexoTitulo(titulo, tipoAnexo) {
        return this._http.get('titulo/anexo', {
            params: {
                cd_apresentante: this._store.getters.cdApresentante,
                id_titulo: titulo.id_titulo,
                tp_anexo: tipoAnexo
            }
        });
    }

    baixarInstrumentos(titulo) {
        return this._http.get('anexo/baixar', {
            responseType: 'arraybuffer',
            params: {
                cd_apresentante: this._store.getters.cdApresentante,
                id_titulo: titulo.id_titulo,
                tp_anexo: 'IP'
            }
        });
    }

    salvarOferta(data) {
        var response = null;
        const url = process.env.VUE_APP_URL_BACK_OFFICE;
        if (data.id) {
            let path = '/protestado/api/b2b/titulos-oferta/' + data.id + '/';
            response = Vue.http.put(url + path, data);
        } else {
            let path = '/protestado/api/b2b/titulos-oferta/';
            response = Vue.http.post(url + path, data);
        }
        return response;
    }

    desabilitarOferta(data) {
        var response = null;
        const url = process.env.VUE_APP_URL_BACK_OFFICE;
        if (data.id) {
            let path = '/protestado/api/b2b/titulos-oferta/?id=' + data.id;
            response = Vue.http.delete(url + path, data);
        }
        return response;
    }

    async listaSituacoesTitulo(callback = null, allStatus = false) {
        let url = allStatus
            ? '/status-titulo'
            : '/status-titulo/' + this._store.getters.cdApresentante;

        await this._http.get(process.env.VUE_APP_RECUPERI_API + url, {}).then(
            response => {
                let situacoesObj = [];

                situacoesObj.push({
                    cd_status: null,
                    nm_status: 'Selecione Status',
                    disabled: true
                });
                for (var [key, value] of Object.entries(response.body)) {
                    situacoesObj.push({
                        cd_status: value,
                        nm_status: key
                    });
                }

                situacoesObj.push({
                    cd_status: 99999,
                    nm_status: 'EM REVISÃO'
                });

                let storeName = allStatus
                    ? 'setTodasSituacoesTitulo'
                    : 'setSituacoesTitulo';

                this._store.commit(storeName, situacoesObj);

                if (callback) {
                    callback(situacoesObj);
                }
            },
            error => {
                console.log(error);
            }
        );
    }

    listaCarteiras() {
        this._http
            .post('carteira', {
                cd_apresentante: this._store.getters.cdApresentante
            })
            .then(
                response => {
                    let carteirasObj = [];

                    carteirasObj.push('Carteira');
                    for (let i in response.body) {
                        carteirasObj.push(response.body[i]);
                    }
                    this._store.commit('setCarteiras', carteirasObj);
                },
                error => {
                    console.log(error);
                }
            );
    }

    async getWalletWithSearch(search) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + `carteira/${search}`,
                {
                    params: {
                        cd_apresentante: this._store.getters.cdApresentante
                    },
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }
    uploadTilulos(file, fileInfo) {
        var formData = new FormData();
        formData.append('file', file, file.name);
        formData.append(
            'json',
            JSON.stringify({
                cd_apresentante: this._store.getters.cdApresentante,
                id_user: this._store.getters.idUser,
                fileInfo
            })
        );

        return this._http.post('remessapre/xls', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    reapresentarTitulo(titulo) {
        return this._http.post(
            'api/remessa',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                titulos: [titulo]
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    updateStatus(id_titulo, cd_status, cd_irregularidade = null) {
        return this._http.patch(
            `titulos/${id_titulo}/status`,
            {
                cd_status: cd_status,
                cd_irregularidade: cd_irregularidade
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    async trocarContatoDevedor(devedor) {
        try {
            if (devedor.cd_comprador != null) {
                devedor.cd_apresentante = devedor.cd_comprador;
            }
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'titulo/correcao',
                devedor,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response;
        } catch (error) {
            throw error?.response;
        }
    }

    desativarMailing(titulo) {
        return this._http.put(
            'titulo/desativar_mensageria',
            {
                cd_apresentante: titulo.cd_comprador || titulo.cd_apresentante,
                id_titulo: titulo.id_titulo
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    async getCoodevedores(titulo) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'titulo/devedor',
                {
                    params: {
                        cd_apresentante: titulo.cd_apresentante,
                        id_titulo: titulo.id_titulo
                    },
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async addCoodevedor(coodevedor) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'titulo/devedor',
                coodevedor,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response?.data?.mensagem;
        } catch (error) {
            throw error?.response;
        }
    }

    async deleteCoodevedor(coodevedor) {
        try {
            const response = await axios.delete(
                process.env.VUE_APP_RECUPERI_API + 'titulo/devedor',
                {
                    params: {
                        cd_apresentante: this._store.getters.cdApresentante,
                        id_titulo: coodevedor.id_titulo,
                        id_devedor: coodevedor.id_devedor
                    },
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response?.data?.mensagem;
        } catch (error) {
            throw error?.response;
        }
    }

    exportarTitulosXls(filtros) {
        return this._http.post(
            'consulta_titulos_xls',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                filtros,
                modelo_relatorio: 'xls'
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    exportarTitulosEmails(filtros, emails, is_used) {
        return this._http.post('exportar_titulos_sqs', {
            is_used: is_used,
            cd_apresentante: this._store.getters.cdApresentante,
            filtros,
            emails,
            modelo_relatorio: 'xls'
        });
    }

    tituloimpressao(titulo) {
        return this._http.post(
            'consulta_relatorio_detalhe_pdf',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                id_titulo: titulo.id_titulo
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    historicoImpressao(titulo) {
        return this._http.post(
            'consultar_titulo/historico/emails',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                ds_nosso_numero: titulo.ds_nosso_numero,
                id_titulo: titulo.id_titulo

            },
            {
                responseType: 'arraybuffer'
            }
        );
    }
    historicoImpressaoComponent(titulo) {
        return this._http.post(
            'consultar_titulo/historico/emails',
            {
                cd_apresentante: titulo.cd_apresentante,
                ds_nosso_numero: titulo.ds_nosso_numero,
                id_titulo: titulo.id_titulo
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    getDetalheEmailLog(logId, cdApresentante) {
        return this._http.get(`emails/log/${logId}`, {
            params: {
                cd_apresentante:
                    cdApresentante || this._store.getters.cdApresentante
            }
        });
    }

    relatorioPdfEmail(filtros, emails) {
        return this._http.post(
            'exportar_titulos_sqs',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                filtros,
                emails,
                modelo_relatorio: 'pdf'
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    relatorioPdfTela(filtros) {
        return this._http.post(
            'consulta_relatorio_lista_pdf',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                filtros,
                modelo_relatorio: 'pdf'
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    relatorioCsvTela(filtros) {
        return this._http.post(
            'consulta_titulos_csv',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                filtros,
                modelo_relatorio: 'csv'
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    //relatório abaixo, era modelo_relatorio: 'pdf_detalhado', foi transformado em csv
    relatoriodetalhes(filtros, emails) {
        return this._http.post(
            'exportar_titulos_sqs',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                filtros,
                emails,
                modelo_relatorio: 'csv'
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    corrigeTitulo(
        id_titulo,
        nm_devedor_abreviado,
        ds_endereco_devedor_abreviado,
        cd_status
    ) {
        return this._http.post('titulo/correcao', {
            cd_apresentante: this._store.getters.cdApresentante,
            id_titulo: id_titulo,
            nm_devedor_cra: nm_devedor_abreviado,
            ds_endereco_devedor_cra: ds_endereco_devedor_abreviado,
            cd_status: cd_status
        });
    }

    cancelaTitulo(data) {
        return this._http.post('api/cancelamento/lote', {
            cd_apresentante: this._store.getters.cdApresentante,
            titulos: data,
            tipo_cancelamento: 'C'
        });
    }

    anuenciaTitulo(data) {
        return this._http.post('api/cancelamento/lote', {
            cd_apresentante: this._store.getters.cdApresentante,
            titulos: data,
            tipo_cancelamento: 'A'
        });
    }

    desistenciaTitulo(data) {
        return this._http.post('api/cancelamento/lote', {
            cd_apresentante: this._store.getters.cdApresentante,
            titulos: data,
            tipo_cancelamento: 'D'
        });
    }

    cancelaNegociacao(data) {
        return this._http.post(
            'titulos/solicitar-cancelamento-negociacao/bulk',
            data
        );
    }

    verificaUsuarioInativo() {
        return this._http.post('verifica_usuario_inativo', {
            cd_apresentante: this._store.getters.cdApresentante
        });
    }

    async getRelatorioValoresCancelamentoDesistencia(cd_apresentante, data) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    'titulos/simulacao-calculo-desistencia',
                {
                    cd_apresentante: cd_apresentante,
                    id_titulo: data
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response;
        } catch (error) {
            throw error?.response;
        }
    }

    verificaStatus() {
        const url = process.env.VUE_APP_URL_BACK_OFFICE;
        return Vue.http.get(url + '/emails/api/status', {}, {});
    }

    cancelarComando(id_titulo, cd_apresentante, cd_status) {
        return this._http.post('cancelar_comando', {
            id_titulo: id_titulo,
            cd_apresentante: cd_apresentante,
            cd_status: cd_status
        });
    }

    reenviarComando(id_titulo) {
        return this._http.get(`titulos/${id_titulo}/reenviar-comando`, {});
    }

    getCartorios(cidade) {
        return this._http.get('cartorios', {
            params: {
                cd_ibge_comarca: cidade
            }
        });
    }

    listarComentarios(id_titulo) {
        return this._http.get('titulo/comentario', {
            params: {
                id_titulo: id_titulo
            }
        });
    }

    criarComentario(comentario, id_titulo) {
        return this._http.post('titulo/comentario', {
            id_titulo: id_titulo,
            comentario: comentario
        });
    }

    async getMunicipios() {
        return this._http.get('utils/municipios', {});
    }

    salvarComarca(
        protocolo,
        dataApontamento,
        cartorio,
        municipio,
        id_titulo,
        cd_apresentante
    ) {
        return this._http.put('consulta_titulo/detalhe', {
            cd_apresentante: cd_apresentante,
            id_titulo: id_titulo,
            cd_municipio: municipio,
            nu_cartorio: cartorio,
            nu_protocolo: protocolo,
            dt_protocolo: dataApontamento
        });
    }

    async getListFiles(params) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'titulo/arquivo',
                {
                    params,
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async downloadFile(params) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'titulo/arquivo/download',
                {
                    params,
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    },
                    responseType: 'arraybuffer'
                }
            );

            return response;
        } catch (error) {
            throw error?.response;
        }
    }

    async deleteHistoryStatus(id_historico) {
        try {
            const response = await axios.delete(
                process.env.VUE_APP_RECUPERI_API + 'titulo/historico',
                {
                    data: {
                        id_historico: id_historico
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response?.data?.mensagem;
        } catch (error) {
            throw error?.response;
        }
    }

    async updateHistoryStatus(id_historico, dadosHistorico) {
        try {
            const response = await axios.put(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/historico/${id_historico}`,
                dadosHistorico,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response?.data;
        } catch (error) {
            throw error?.response;
        }
    }

    solicitaInstrumento(id_titulo, cd_apresentante) {
        return this._http.put(
            `instrumentoprotesto/solicitacao/titulo/${id_titulo}`,
            {
                cd_apresentante: cd_apresentante
            }
        );
    }

    exportarFinanceiroResumido(filtros, emails) {
        return this._http.post(
            'exportar_titulos_sqs',
            {
                cd_apresentante: this._store.getters.cdApresentante,
                filtros,
                emails,
                modelo_relatorio: 'repasse_relatorio_xls'
            },
            {
                responseType: 'arraybuffer'
            }
        );
    }

    async consultarTitulosRepasse(pagina, titulosPorPagina, filtros) {
        return this._http.post('consulta_titulo/repasse', {
            cd_apresentante: this._store.getters.cdApresentante,
            filtros,
            pagina: pagina,
            titulos_por_pagina: titulosPorPagina
        });
    }

    async atualizarAgrupador(id_titulo, novo_ds_agrupador) {
        return this._http.put('titulo/atualizacao_agrupador', {
            cd_apresentante: this._store.getters.cdApresentante,
            id_titulo: id_titulo,
            novo_ds_agrupador: novo_ds_agrupador
        });
    }

    async atualizarAgrupadorLote(titulos, novo_ds_agrupador) {
        return this._http.put('titulo/atualizacao_agrupador/lote', {
            cd_apresentante: this._store.getters.cdApresentante,
            titulos: titulos,
            novo_ds_agrupador: novo_ds_agrupador
        });
    }

    async baixarInstrumentosLote(titulos, emails) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    'instrumentoprotesto/baixar/lote',
                {
                    cd_apresentante: this._store.getters.cdApresentante,
                    titulos: titulos,
                    emails: emails
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async invalidarInstrumento(titulo) {
        try {
            const response = await axios.patch(
                process.env.VUE_APP_RECUPERI_API +
                    'instrumentoprotesto/invalida',
                {
                    cd_apresentante: this._store.getters.cdApresentante,
                    id_anexo_instrumento: titulo.id_anexo_instrumento,
                    ds_nosso_numero: titulo.ds_nosso_numero
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async anexarArquivo(objetoAnexo) {
        try {
            const formData = new FormData();
            formData.append('cd_apresentante', this._store.getters.cdApresentante);
            formData.append('titulos[0][ds_nosso_numero]', objetoAnexo.ds_nosso_numero);
            formData.append('titulos[0][id_titulo]', this._store.getters.getTitulo.id_titulo);
            formData.append('titulos[0][arquivo]', objetoAnexo.arquivo);

            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    `titulo/${this._store.getters.getTitulo.id_titulo}/upload/anexo`,
                formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response?.data?.mensagem;
        } catch (error) {
            throw error?.response;
        }
    }

    async substituirAnexo(objetoAnexo) {
        try {
            const formData = new FormData();
            formData.append('cd_apresentante', this._store.getters.cdApresentante);
            formData.append('titulos[0][ds_nosso_numero]', objetoAnexo.ds_nosso_numero);
            formData.append('titulos[0][id_titulo]', this._store.getters.getTitulo.id_titulo);
            formData.append('titulos[0][arquivo]', objetoAnexo.arquivo);

            const response = await axios.put(
                process.env.VUE_APP_RECUPERI_API +
                    `titulo/${this._store.getters.getTitulo.id_titulo}/upload/anexo`,
                formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response?.data?.mensagem;
        } catch (error) {
            throw error?.response;
        }
    }

    async anexarArquivoLote(formData) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'titulo/upload/anexo/lote',
                formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );

            return response?.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async baixarAnexo(titulo) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'anexo/baixar',
                {
                    params: {
                        cd_apresentante: this._store.getters.cdApresentante,
                        id_titulo: titulo.id_titulo,
                        tp_anexo: 'AN'
                    },
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    },
                    responseType: 'arraybuffer'
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    /**
     * Realiza a transferência de custódia de títulos entre apresentantes
     * @param {Object} dados Objeto contendo apresentanteOrigem, apresentanteDestino e lista de titulos
     */
    async transferirCustodiaTitulos(dados) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'titulos/cessao',
                dados,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response;
        } catch (error) {
            throw error?.response;
        }
    }

    async processarArquivoDevedores(arquivo, confirmacao = 0) {
        try {
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            formData.append(
                'cd_apresentante',
                this._store.getters.cdApresentante
            );
            formData.append('confirmacao', confirmacao);
            const response = await this._http.post(
                'lote/coodevedores/importar',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response;
        } catch (error) {
            console.error(
                'Erro no service de processar arquivo de devedores:',
                error
            );
            throw error?.response || error;
        }
    }
}
